'use strict';

namespace Core.Customer {

    import DestinationSummary = Destinations.DestinationSummary;
    import DestinationType = Destinations.DestinationType;

    class RecentSearchCard {

        private icons = {
            1: ['flights'],
            2: ['hotels'],
            3: ['flights', 'hotels']
        };

        private titles = {
            1: 'SEARCHUNITTITLEFLIGHTS',
            2: 'SEARCHUNITTITLEHOTELS',
            3: 'SEARCHUNITTITLEHOLIDAYS'
        };

        // Attr
        model: any;
        viewModel: RecentSearchContentCard|null = null;

        private busy: boolean = false;

        constructor (
            private $scope: ng.IScope,
            private imageService: any,
            private savedSearchService: any,
            private basketService: any,
            private analytics: any,
            private dateUtil: any
        ) {
            this.$scope.$watch('rs.model', (val, old) => {
                if (val) {
                    this.viewModel = this.enhanceModel(val);
                }
            });
        }

        private enhanceModel(s: any): RecentSearchContentCard {
            let details = s.DisplayDetails;
           // get destination for image
            let dest: DestinationSummary;
            if (details.Destinations) {
                // if hotel, use that
                let first: DestinationSummary = _.head(<DestinationSummary[]>details.Destinations);
                if (first.Type === DestinationType.Establishment) {
                    dest = first;
                } else {
                    // get province OR first destination
                    dest = _.find(<DestinationSummary[]>details.Destinations, ['Type', DestinationType.Province])
                        || first;
                }
            } else {
                // flight only - use airport
                dest = details.DestinationAirports[0].Destination;
            }

            // Return the display details only
            return <RecentSearchContentCard>_.assignIn(details, {
                Title: dest.Title,
                ImageUrl: this.imageService.getDestinationImage({ Id: dest.Id, Type: dest.Type }),
                Icons: this.icons[s.SearchType],
                TitleResource: this.titles[s.SearchType],
                StartDate: s.FromDate.Date,
                EndDate: s.ToDate.Date,
                Duration: s.OneWayOnly ? null : this.dateUtil.numberOfNights(s.FromDate.Date, s.ToDate.Date),
                Adults: s.Adults,
                Children: s.Children,
                Rooms: s.Rooms ? s.Rooms.length : null
            });
        }

        // public deleteSearch(event, s: any) {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     this.savedSearchService.removeSavedSearch(s.SavedSearchId);
        // }

        public restoreSearch(event, s: any) {
            event.preventDefault();
            if (!this.busy) {
                this.busy = true;
                this.savedSearchService.restoreSearch(s)
                    .then(() => {
                        this.analytics.trackEvent({ label: 'restore saved search' });
                        return this.basketService.startWorkflow(this.basketService.workflowType[s.SearchType]);
                    })
                    .catch()
                    .then(() => this.busy = false);
            }
        }
    }
    angular
        .module('core')
        .directive('recentSearchCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: RecentSearchCard,
                controllerAs: 'rs',
                bindToController: {
                    model: '='
                },
                templateUrl: 'partials/customer/recentsearchcontentcard'
            };
        });
}
